<template>
  <div class="label-con flex flex-row align-center justify-between">
    <div class="flex flex-row align-center">
      <div class="icon" />
      <div class="label">{{ label }}</div>
    </div>
    <div>
      <slot name="options" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ModelHeader",
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">

.label-con {
  margin-bottom: 12px;

  .icon {
    width: 4px;
    height: 14px;
    background: #165DFF;
    border-radius: 0 0 0 0;
    margin-right: 8px;
  }

  .label {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: bold;
    font-size: 16px;
    color: #1D2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
